import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AdTopBanner, AdBottomBanner } from '../components/AdSense';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Terms of Use</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-6">Terms of Use</h1>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6 space-y-6 text-gray-300">
            <p className="text-sm text-gray-500">Last Updated: January 2025</p>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By accessing and using PercentageCalculatorPlus.com, you accept and agree to be bound by these Terms of Use. 
                If you do not agree to these terms, please do not use our website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">2. Use of Calculators</h2>
              <p className="leading-relaxed">
                Our calculators are provided for informational and educational purposes only. While we strive for accuracy, 
                results should not be considered as professional financial, medical, or legal advice. Always consult with 
                qualified professionals for important decisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">3. Accuracy Disclaimer</h2>
              <p className="leading-relaxed">
                We make every effort to ensure our calculators provide accurate results. However, we do not guarantee the 
                accuracy, completeness, or reliability of any calculations. Users are responsible for verifying results 
                independently when making important decisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">4. Intellectual Property</h2>
              <p className="leading-relaxed">
                All content on this website, including text, graphics, logos, and software, is the property of 
                PercentageCalculatorPlus and is protected by copyright laws. You may not reproduce, distribute, or 
                create derivative works without our written permission.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">5. Limitation of Liability</h2>
              <p className="leading-relaxed">
                PercentageCalculatorPlus shall not be liable for any direct, indirect, incidental, or consequential 
                damages arising from the use or inability to use our calculators or website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">6. Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon 
                posting to the website. Continued use of the website constitutes acceptance of modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">7. Contact</h2>
              <p className="leading-relaxed">
                If you have questions about these Terms of Use, please <Link to="/contact" className="text-cyan-400 hover:text-cyan-300">contact us</Link>.
              </p>
            </section>
          </div>

          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
